import { useEffect, useState } from "react";
import { IS_EMBED } from "./embedMode";
import { EmbedTheme, getThemeOverride, subscribeTheme } from "./embedBridge";

/**
 * The parent page's validated theme override (SDK `theme`), or {} outside embed mode / before it arrives.
 * Callers apply it ahead of the tenant branding: parent override, then tenant branding, then Inkfree default.
 */
export const useEmbedTheme = (): EmbedTheme => {
  const [theme, setTheme] = useState<EmbedTheme>(IS_EMBED ? getThemeOverride() : {});
  useEffect(() => {
    if (!IS_EMBED) return;
    return subscribeTheme((next) => setTheme({ ...next }));
  }, []);
  return theme;
};
